<template>
  <OwnStack v-if="isVisible" class="own-full-page-editor">
    <FullPageEditorHeading @close="closeModal">
      <template #topbar>
        <slot name="topbar"></slot>
      </template>
    </FullPageEditorHeading>
    <slot name="content"></slot>
  </OwnStack>
</template>

<script>
import { OwnStack } from '../OwnStack'

import FullPageEditorHeading from './FullPageEditorHeading'

/**
 * @deprecated use FullPageEditor from `@/components/layouts`
 */
export default {
  name: 'OwnFullPageEditor',
  components: {
    FullPageEditorHeading,
    OwnStack,
  },
  props: {
    /** Show Modal */
    value: { type: Boolean, default: false },
  },
  computed: {
    isVisible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    closeModal() {
      this.isVisible = false
    },
  },
}
</script>

<style lang="scss">
.own-full-page-editor {
  position: fixed;
  z-index: 200;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  margin: 0;
  background-color: $white;
}
</style>
